import Axios from "@/utils/Axios";
import Axios2 from "@/utils/Axios2";

/**
 * 处理备注变化
 */
export function handleRemarkChange(context, row) {
  // 可以在这里添加输入验证逻辑
  if (row.comment && row.comment.length > 100) {
    context.$message.warning('备注长度不能超过100个字符');
    row.comment = row.comment.slice(0, 100);
  }
}

/**
 * 保存隐患设备备注
 */
export function saveRemarkDevice(context, row) {
  if (!row.comment) {
    context.$message.warning('请输入备注内容');
    return;
  }

  // 调用API保存备注
  let param = {};
  param.method = "get";
  param.url = "/api/v1/risk/device/comment/update";
  param.params = {
    deviceId: row.id, // 设备ID
    comment: row.comment,
  }

  return Axios2.ajax(param).then((res) => {
    if (res.code === 0) {
      context.$message.success('备注保存成功');
    } else {
      context.$message.error(res.msg || '保存失败');
    }
  }).catch(() => {
    context.$message.error('保存失败');
  });
}

/**
 * 保存误报源定位备注
 */
export function saveRemarkMisreport(context, row) {
  if (!row.comment) {
    context.$message.warning('请输入备注内容');
    return;
  }

  // 调用API保存备注
  let param = {};
  param.method = "get";
  param.url = "/api/v1/risk/misreport/device/comment/update";
  param.params = {
    deviceId: row.id, // 设备ID
    comment: row.comment,
  }

  return Axios2.ajax(param).then((res) => {
    if (res.code === 0) {
      context.$message.success('备注保存成功');
    } else {
      context.$message.error(res.msg || '保存失败');
    }
  }).catch(() => {
    context.$message.error('保存失败');
  });
}

/**
 * 上传处理
 */
export function uploadDeal(context) {
  context.dialogVisible = false
  let status = context.checked ? '2' : '3'
  let param = {};
  param.method = "post";
  param.url = "/monitorBoard/risk/handle";
  param.data = {
    riskId: context.riskId,
    measure: context.textarea1,
    status: status,
  }
  return Axios.ajax(param).then((res) => {
    if (res.resultCode === '0') {
      context.$message({
        type: 'success',
        message: '提交成功!'
      });
      context.showdeal = false
      context.getRiskList()
    } else {
      context.$message({
        type: 'error',
        message: res.msg
      });
    }
  })
}

/**
 * 重置
 */
export function reset(context) {
  context.statius = ""
  context.hisedtm = ""
  context.hissttm = ""
  context.riskpage = 10
  context.nowpage = 1
  context.getRiskList()
}

/**
 * 重置2
 */
export function reset2(context) {
  context.hisedtm2 = ""
  context.hissttm2 = ""
  context.riskpage1 = 10
  context.nowpage1 = 1
  context.getRisktypeall()
}

/**
 * 返回
 */
export function returnback(context) {
  context.ishis = !context.ishis
  context.riskpage = 10
  context.nowpage = 1
}

/**
 * 打开详情
 */
  export function opendetail(context, data) {
  context.alertLevel = data.alertLevel
  context.alertLevelName = data.alertLevelName

  context.ishis = !context.ishis
  context.riskpage = 10
  context.nowpage = 1
  context.getRisktypeall()
}

/**
 * 打开历史图层
 */
export function openhisLayer(context, data) {
  context.dialogVisible = true
  context.getriskdeal(data.riskId)
}

/**
 * 处理页面点击
 */
export function handlepageClick(context, data) {
  context.activeName = data.name
  context.riskpage = 10
  context.nowpage = 1
}

/**
 * 是否今天
 */
export function isToday(context, date) {
  const today = new Date();
  const compareDate = new Date(date);
  return today.toDateString() === compareDate.toDateString();
}

/**
 * 更改日期
 */
export function changeDate(context, offset) {
  // 将 todaytm 转为日期对象
  const currentDate = new Date(context.newtm);
  // 根据 offset（-1 或 1）调整日期
  currentDate.setDate(currentDate.getDate() + offset);
  // 更新 newtm
  context.newtm = currentDate.toISOString().split('T')[0];
  context.getRiskTimePeriodAnalyze();
}

/**
 * 今天日期
 */
export function todayDate(context) {
  context.newtm = context.edtm
  context.getRiskTimePeriodAnalyze();
}

/**
 * 最后一小时
 */
export function lastHour(context) {
  let param = {};
  param.method = "post";
  param.url = "/monitorBoard/riskTimePeriodAnalyze";

  param.data = {
    startDateTime: context.yesterdayDateTime,
    monitorSiteId: context.saveid,
    endDateTime: context.currentDateTime,
  }
  Axios.ajax(param).then((res) => {
    if (res.data) {
      // 调用方法处理数据并绘制图表
      context.initTimelineChart(res.data, true);
    }
  })
  context.newtm = context.edtm
}
